/**
 * Application Configuration
 * Centralized configuration for the entire application
 */

interface Config {
  API_BASE_URL: string;
  HUB_BASE_URL: string;
  ADMIN_APP_URL: string;
  API_TIMEOUT: number;
  APP_NAME: string;
  APP_VERSION: string;
  IS_DEVELOPMENT: boolean;
  IS_PRODUCTION: boolean;
  GOOGLE_API_KEY: string;
  GOOGLE_GEOCODE_URL: string;
  GOOGLE_MAPS_URL: string;
  // Email domains allowed to self-register. Empty array = no restriction.
  ALLOWED_EMAIL_DOMAINS: string[];
  // AdSense Configuration
  ADSENSE_SLOTS: {
    userDashboard_adSlot: string;
    messageWindow_adSlot: string;
    matchesPage_adSlot: string;
  };
  // AdMob Configuration
  ADMOB_AD_UNITS: {
    userDashboard: string;
    messageWindow: string;
    matchesPage: string;
  };
}

const config: Config = {
  API_BASE_URL: import.meta.env.VITE_APP_API_BASE_URL,
   HUB_BASE_URL:import.meta.env.VITE_APP_HUB_BASE_URL ,
   ADMIN_APP_URL: import.meta.env.VITE_APP_ADMIN_URL,
   API_TIMEOUT: parseInt(import.meta.env.VITE_APP_API_TIMEOUT || '30000', 10),

  APP_NAME: import.meta.env.VITE_APP_NAME || 'ISentryx',
  APP_VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',

  IS_DEVELOPMENT: import.meta.env.NODE_ENV === 'development',
  IS_PRODUCTION: import.meta.env.NODE_ENV === 'production',

  GOOGLE_API_KEY: import.meta.env.VITE_APP_GOOGLE_API_KEY || '',

  GOOGLE_GEOCODE_URL: `https://maps.googleapis.com/maps/api/geocode/json?latlng={latitude},{longitude}&key=${import.meta.env.VITE_APP_GOOGLE_API_KEY}`,

  GOOGLE_MAPS_URL: `https://maps.googleapis.com/maps/api/js?key=${import.meta.env.VITE_APP_GOOGLE_API_KEY}&libraries=places`,

  ALLOWED_EMAIL_DOMAINS: (import.meta.env.VITE_APP_ALLOWED_EMAIL_DOMAINS || '')
    .split(',')
    .map((domain: string) => domain.trim().toLowerCase())
    .filter(Boolean),

  ADSENSE_SLOTS: {
    userDashboard_adSlot: '6793601411',
    messageWindow_adSlot: '3078019000',
    matchesPage_adSlot: '6793601411',
  },

  ADMOB_AD_UNITS: {
    userDashboard: 'ca-app-pub-9294385557744731/8030023746',
    messageWindow: 'ca-app-pub-9294385557744731/8139236356',
    matchesPage: 'ca-app-pub-9294385557744731/6796833123', // Using same as userDashboard for now
  },
};

export default config;
